import { TableCell, TableRow, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';

export interface GenericHeader {
  id: string;
  label?: string;
  alignRight?: boolean;
}

export interface GenericTableHeadProps {
  headers: GenericHeader[];
}

const GenericTableHead: FC<GenericTableHeadProps> = ({ headers }) => {
  const { t } = useTranslation();

  return (
    <TableRow>
      {headers.map((header) => {
        return (
          <TableCell {...(header.alignRight && { align: 'right' })} key={header.id}>
            <Typography variant='subtitle1'>{header.label && t(header.label)}</Typography>
          </TableCell>
        );
      })}
    </TableRow>
  );
};

export default GenericTableHead;
